<div class="site-menu" [class.menu-expanded]="menuExpanded" [hidden]="hideShell">
  <ndt-site-menu
    id="5e9334ff-bf41-41c3-b08a-63101196d8ad"
    class="navigation"
    [class.menu-expanded]="menuExpanded"
    [menuItems]="menuItems"
    [expanded]="menuExpanded"
    [currentUser]="currentUser"
  ></ndt-site-menu>

  @if (!adminToken) {
    <div class="navigation-bottom">
      <mat-divider></mat-divider>
      <button
        type="button"
        class="expand-menu"
        [class.menu-expanded]="menuExpanded"
        (click)="onToggleMenuClicked()"
        [matTooltip]="menuExpanded ? 'Collapse Menu' : 'Expand Menu'"
        >
        <mat-icon>
          {{ menuExpanded ? 'keyboard_arrow_left' : 'keyboard_arrow_right' }}
        </mat-icon>
      </button>
    </div>
  }
</div>
<div
  class="site-layout-content"
  [class.top-bar-visible]="showTopBar && !hideShell"
  [class.menu-expanded]="menuExpanded"
  [class.menu-visible]="!hideShell"
  >
  @if (showTopBar && !hideShell) {
    <div class="global-search-bar">
      @if (!mobileView) {
        <div class="brand-logo" [routerLink]="['/']" [class.menu-expanded]="menuExpanded">
          <ndt-logo [logoWidth]="100" [logoHeight]="40"></ndt-logo>
        </div>
      }
      @if (mobileView) {
        <div class="brand-logo" [routerLink]="['/']">
          <svg
            class="logo"
            xmlns="http://www.w3.org/2000/svg"
            width="77"
            height="33"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 77 30"
            >
            <defs>
              <style>
                .d {
                fill: #b7d98c;
              }
              .e,
              .f {
              fill: #3777bc;
            }
            .e,
            .g {
            mix-blend-mode: screen;
          }
          .h {
          isolation: isolate;
        }
        .i {
        clip-path: url(#b);
      }
      .j {
      clip-path: url(#c);
    }
    .k {
    fill: #a0cf67;
  }
  .l {
  fill: none;
}
</style>
<clipPath id="b">
  <path
    d="M69.42,.42c.18,.17,.35,.35,.52,.52,7.85,8.1,7.85,20.02,0,28.12-.17,.18-.34,.35-.52,.52-.59,.57-1.54,.56-2.11-.03-.58-.59-.56-1.54,.03-2.11,.16-.15,.31-.3,.46-.46,6.72-6.93,6.72-17.02,0-23.95-.15-.15-.3-.31-.46-.46-.59-.58-.6-1.52-.03-2.12,.58-.59,1.52-.61,2.11-.03h0Zm-3.39,2.48c.15,.14,.29,.29,.43,.43,6.51,6.72,6.51,16.61,0,23.33-.14,.14-.28,.29-.43,.43-.59,.58-1.54,.56-2.11-.03-.58-.59-.56-1.54,.03-2.11,.12-.12,.25-.25,.37-.37,5.37-5.54,5.37-13.62,0-19.16-.12-.12-.24-.25-.37-.37-.59-.58-.61-1.52-.03-2.11,.58-.59,1.52-.6,2.11-.03h0Zm-9.02,13.59h-8.15c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h8.15c.83,0,1.5,.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
    style="fill: none"
    />
  </clipPath>
  <clipPath id="c">
    <path
      d="M51.46,11.67c0,.83,.67,1.5,1.5,1.5s1.5-.67,1.5-1.5v-.11h4.78c.54,0,1.02-.29,1.28-.71l1.44-2.04c2.97,3.77,2.97,8.62,0,12.38l-1.49-2.11h0c-.29-.42-.76-.64-1.23-.64h-4.78v-.11c0-.83-.67-1.5-1.5-1.5s-1.5,.67-1.5,1.5v1.61c0,.83,.67,1.5,1.5,1.5h5.51l2.06,2.92c.05,.09,.12,.17,.19,.25,.57,.6,1.52,.63,2.12,.06h0c.22-.21,.42-.41,.62-.62,4.98-5.27,4.98-12.81,0-18.07-.18-.18-.35-.36-.54-.54-.07-.08-.16-.15-.25-.22-.68-.48-1.61-.31-2.09,.36h0l-2.11,2.99h-5.51c-.83,0-1.5,.67-1.5,1.5v1.61h0Z"
      style="fill: none"
      />
    </clipPath>
  </defs>
  <g style="isolation: isolate">
    <g id="a">
      <g>
        <g>
          <path
            d="M10.91,14.69c0,.26,0,.54,.02,.83,.02,.3,.04,.6,.07,.91L3.25,6.64c-.1-.13-.2-.23-.28-.3-.08-.08-.17-.13-.26-.17-.09-.04-.19-.07-.3-.08-.11-.01-.25-.02-.42-.02H0V22.38H3.34V13.63c0-.24,0-.49-.02-.77-.01-.27-.03-.55-.05-.83l7.69,9.72c.19,.24,.38,.4,.58,.49,.2,.09,.45,.14,.74,.14h1.97V7.45l2.45-1.4h-5.79V14.69Z"
            style="fill: #3777bc"
            />
            <path
              d="M42.17,6.06h-10.41v1.43l-1.26,1.57h5.85v13.32h3.79V9.06h3.33c.69,0,1.26-.57,1.26-1.27v-1.74h-2.56Z"
              style="fill: #3777bc"
              />
              <g style="mix-blend-mode: screen">
                <path
                  d="M10.91,14.34c1.11,.02,2.22,.04,3.34,.05V7.45l2.45-1.4h-5.79V14.34Z"
                  style="fill: #3777bc"
                  />
                  <path
                    d="M9.32,14.31L3.25,6.64c-.1-.13-.2-.23-.28-.3-.08-.08-.17-.13-.26-.17-.09-.04-.19-.07-.3-.08-.11-.01-.25-.02-.42-.02H0v7.98c1.11,.04,2.22,.08,3.34,.12v-.53c0-.24,0-.49-.02-.77-.01-.27-.03-.55-.05-.83l1.72,2.18c1.43,.04,2.88,.08,4.33,.11Z"
                    style="fill: #3777bc"
                    />
                  </g>
                  <g>
                    <path
                      d="M51.46,11.67c0,.83,.67,1.5,1.5,1.5s1.5-.67,1.5-1.5v-.11h4.78c.54,0,1.02-.29,1.28-.71l1.44-2.04c2.97,3.77,2.97,8.62,0,12.38l-1.49-2.11h0c-.29-.42-.76-.64-1.23-.64h-4.78v-.11c0-.83-.67-1.5-1.5-1.5s-1.5,.67-1.5,1.5v1.61c0,.83,.67,1.5,1.5,1.5h5.51l2.06,2.92c.05,.09,.12,.17,.19,.25,.57,.6,1.52,.63,2.12,.06h0c.22-.21,.42-.41,.62-.62,4.98-5.27,4.98-12.81,0-18.07-.18-.18-.35-.36-.54-.54-.07-.08-.16-.15-.25-.22-.68-.48-1.61-.31-2.09,.36h0l-2.11,2.99h-5.51c-.83,0-1.5,.67-1.5,1.5v1.61h0Z"
                      style="fill: #3777bc"
                      />
                      <path
                        d="M69.42,.42c.18,.17,.35,.35,.52,.52,7.85,8.1,7.85,20.02,0,28.12-.17,.18-.34,.35-.52,.52-.59,.57-1.54,.56-2.11-.03-.58-.59-.56-1.54,.03-2.11,.16-.15,.31-.3,.46-.46,6.72-6.93,6.72-17.02,0-23.95-.15-.15-.3-.31-.46-.46-.59-.58-.6-1.52-.03-2.12,.58-.59,1.52-.61,2.11-.03h0Z"
                        style="fill: #a0cf67"
                        />
                        <path
                          d="M66.03,2.91c.15,.14,.29,.29,.43,.43,6.51,6.72,6.51,16.61,0,23.33-.14,.14-.28,.29-.43,.43-.59,.58-1.54,.56-2.11-.03-.58-.59-.56-1.54,.03-2.11,.12-.12,.25-.25,.37-.37,5.37-5.54,5.37-13.62,0-19.16-.12-.12-.24-.25-.37-.37-.59-.58-.61-1.52-.03-2.11,.58-.59,1.52-.6,2.11-.03h0Z"
                          style="fill: #a0cf67"
                          />
                          <path
                            d="M57.01,16.5h-8.15c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h8.15c.83,0,1.5,.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
                            style="fill: #3777bc"
                            />
                            <g style="clip-path: url(#b)">
                              <path
                                d="M204.76,25.31c-3.44,12.93-72.14,5.88-153.45-15.76C-30.01-12.08-93.13-40.1-89.69-53.03c3.44-12.93,72.14-5.87,153.46,15.76C145.07-15.64,208.2,12.38,204.76,25.31Z"
                                style="fill: #b7d98c"
                                />
                              </g>
                              <g style="clip-path: url(#c)">
                                <path
                                  d="M204.76,25.31c-3.44,12.93-72.14,5.88-153.45-15.76C-30.01-12.08-93.13-40.1-89.69-53.03c3.44-12.93,72.14-5.87,153.46,15.76C145.07-15.64,208.2,12.38,204.76,25.31Z"
                                  style="fill: #3777bc; mix-blend-mode: screen"
                                  />
                                </g>
                              </g>
                              <g>
                                <path
                                  d="M31.13,10.96c-.4-1-.98-1.86-1.72-2.58-.74-.72-1.63-1.29-2.67-1.7-1.04-.41-2.2-.62-3.47-.62h-6.34v2.91h6.34c.72,0,1.37,.12,1.94,.36,.57,.24,1.05,.59,1.44,1.04,.39,.45,.69,1,.9,1.65,.21,.65,.31,1.38,.31,2.18s-.1,1.55-.31,2.2c-.21,.65-.51,1.2-.9,1.65-.39,.45-.87,.8-1.44,1.04-.57,.24-1.21,.36-1.94,.36h-2.53V10.65h-3.81v11.73h6.34c1.27,0,2.42-.2,3.47-.61,1.04-.41,1.93-.97,2.67-1.7,.74-.73,1.31-1.59,1.72-2.59,.41-1,.61-2.09,.61-3.27s-.2-2.26-.61-3.25Z"
                                  style="fill: #3777bc"
                                  />
                                  <g style="mix-blend-mode: screen">
                                    <path
                                      d="M31.13,10.96c-.4-1-.98-1.86-1.72-2.58-.74-.72-1.63-1.29-2.67-1.7-1.04-.41-2.2-.62-3.47-.62h-6.34v2.91h6.34c.72,0,1.37,.12,1.94,.36,.57,.24,1.05,.59,1.44,1.04,.39,.45,.69,1,.9,1.65,.21,.65,.31,1.38,.31,2.18,0,.07,0,.14,0,.21,1.3-.01,2.59-.03,3.88-.05,0-.06,0-.11,0-.17,0-1.17-.2-2.26-.61-3.25Z"
                                      style="fill: #3777bc"
                                      />
                                      <path
                                        d="M16.94,14.43c1.26,.01,2.53,.02,3.81,.02v-3.79h-3.81v3.77Z"
                                        style="fill: #3777bc"
                                        />
                                      </g>
                                    </g>
                                    <path
                                      d="M42.17,6.06h-10.41v1.43l-1.26,1.57h5.85v5.23c1.27-.03,2.53-.06,3.79-.1v-5.13h3.33c.69,0,1.26-.57,1.26-1.27v-1.74h-2.56Z"
                                      style="fill: #3777bc; mix-blend-mode: screen"
                                      />
                                    </g>
                                    <g>
                                      <path
                                        d="M0,24.55H.56c.06,0,.11,.01,.15,.04,.04,.03,.07,.07,.09,.11l.89,2.3c.03,.07,.06,.16,.08,.25,.03,.09,.05,.18,.08,.28,.04-.2,.09-.38,.15-.53l.88-2.3s.04-.08,.08-.11c.04-.03,.09-.05,.15-.05h.57l-1.52,3.77h-.63l-1.52-3.77Z"
                                        style="fill: #a0cf67"
                                        />
                                        <path
                                          d="M4.75,25.6c.2,0,.38,.03,.54,.1,.16,.06,.3,.15,.42,.27,.11,.12,.2,.26,.26,.43,.06,.17,.09,.36,.09,.57s-.03,.4-.09,.57c-.06,.17-.15,.32-.26,.44-.11,.12-.26,.21-.42,.28-.16,.06-.34,.1-.54,.1s-.38-.03-.55-.1c-.16-.07-.3-.16-.42-.28-.12-.12-.21-.26-.27-.44-.06-.17-.1-.36-.1-.57s.03-.4,.1-.57c.06-.17,.15-.31,.27-.43,.12-.12,.25-.21,.42-.27,.16-.07,.35-.1,.55-.1Zm0,2.26c.22,0,.39-.08,.49-.23,.11-.15,.16-.37,.16-.66s-.05-.51-.16-.66c-.11-.15-.27-.23-.49-.23s-.39,.08-.5,.23c-.11,.15-.16,.37-.16,.66s.05,.51,.16,.66c.11,.15,.28,.23,.5,.23Z"
                                          style="fill: #a0cf67"
                                          />
                                          <path d="M7.3,28.32h-.7v-3.77h.7v3.77Z" style="fill: #a0cf67" />
                                          <path
                                            d="M8.77,26.99v1.33h-.7v-3.77h1.23c.25,0,.47,.03,.66,.09,.18,.06,.34,.14,.46,.25,.12,.11,.21,.23,.27,.38,.06,.15,.09,.31,.09,.48s-.03,.35-.09,.5c-.06,.15-.15,.28-.28,.39-.12,.11-.27,.2-.46,.26-.18,.06-.4,.09-.64,.09h-.52Zm0-.55h.52c.13,0,.24-.02,.34-.05,.1-.03,.17-.08,.24-.14,.06-.06,.11-.13,.14-.22,.03-.09,.05-.18,.05-.29s-.01-.19-.05-.27c-.03-.08-.08-.15-.14-.21-.06-.06-.14-.1-.24-.13-.1-.03-.21-.05-.34-.05h-.52v1.36Z"
                                            style="fill: #a0cf67"
                                            />
                                            <path
                                              d="M14.33,25.23s-.04,.07-.06,.08c-.03,.02-.06,.02-.09,.02s-.07-.01-.12-.04c-.04-.03-.1-.06-.15-.09-.06-.03-.13-.06-.21-.09-.08-.03-.17-.04-.28-.04-.1,0-.18,0-.25,.03-.07,.03-.13,.06-.18,.1-.05,.04-.08,.09-.11,.15-.02,.06-.03,.12-.03,.19,0,.09,.02,.16,.07,.22,.05,.06,.12,.11,.2,.15,.08,.04,.17,.08,.28,.11,.1,.03,.21,.07,.32,.11,.11,.04,.21,.08,.32,.13,.1,.05,.2,.11,.28,.19,.08,.07,.15,.17,.2,.28,.05,.11,.07,.24,.07,.4,0,.17-.03,.33-.09,.48-.06,.15-.14,.28-.26,.39-.11,.11-.25,.2-.41,.26-.16,.06-.35,.1-.56,.1-.12,0-.24-.01-.35-.03-.12-.02-.23-.06-.34-.1-.11-.04-.21-.1-.3-.16-.09-.06-.18-.13-.25-.2l.2-.34s.04-.05,.07-.06c.03-.02,.06-.02,.09-.02,.04,0,.09,.02,.14,.05,.05,.04,.11,.08,.18,.12,.07,.04,.15,.08,.24,.12,.09,.04,.21,.05,.33,.05,.2,0,.35-.05,.46-.14,.11-.09,.16-.23,.16-.41,0-.1-.03-.18-.07-.24-.05-.06-.12-.11-.2-.16-.08-.04-.17-.08-.28-.11-.1-.03-.21-.06-.32-.1-.11-.03-.21-.08-.32-.12-.1-.05-.2-.11-.28-.19-.08-.08-.15-.17-.2-.29-.05-.12-.07-.26-.07-.43,0-.14,.03-.27,.08-.4,.05-.13,.13-.25,.24-.35,.11-.1,.24-.18,.39-.24,.15-.06,.33-.09,.53-.09,.22,0,.43,.03,.62,.11,.19,.07,.35,.17,.48,.29l-.17,.33Z"
                                              style="fill: #a0cf67"
                                              />
                                              <path
                                                d="M18.72,26.43c0,.28-.04,.53-.14,.77-.09,.24-.22,.44-.39,.61-.17,.17-.37,.3-.6,.4-.23,.1-.49,.15-.78,.15s-.54-.05-.78-.15c-.24-.1-.44-.23-.6-.4-.17-.17-.3-.38-.39-.61-.09-.23-.14-.49-.14-.77s.04-.53,.14-.77c.09-.24,.22-.44,.39-.61,.17-.17,.37-.31,.6-.4,.24-.1,.5-.15,.78-.15s.55,.05,.78,.15c.23,.1,.44,.23,.6,.4,.17,.17,.3,.37,.39,.61,.09,.23,.14,.49,.14,.77Zm-.72,0c0-.21-.03-.39-.08-.56-.06-.16-.13-.3-.24-.42-.1-.12-.23-.21-.37-.27-.15-.06-.31-.09-.5-.09s-.35,.03-.5,.09c-.15,.06-.27,.15-.38,.27-.1,.11-.18,.25-.24,.42-.05,.16-.08,.35-.08,.56s.03,.39,.08,.56c.06,.16,.14,.3,.24,.42,.1,.11,.23,.2,.38,.26,.15,.06,.31,.09,.5,.09s.35-.03,.5-.09c.15-.06,.27-.15,.37-.26,.1-.11,.18-.26,.24-.42,.05-.16,.08-.35,.08-.56Z"
                                                style="fill: #a0cf67"
                                                />
                                                <path d="M19.87,27.74h1.51v.58h-2.21v-3.77h.7v3.19Z" style="fill: #a0cf67" />
                                                <path
                                                  d="M23.17,27.75c.14,0,.26-.02,.36-.07,.11-.04,.2-.11,.27-.19,.07-.08,.13-.18,.17-.3,.04-.12,.06-.25,.06-.39v-2.26h.7v2.26c0,.23-.04,.43-.11,.62-.07,.19-.17,.36-.31,.5-.14,.14-.3,.24-.49,.32-.19,.08-.41,.12-.65,.12s-.46-.04-.65-.12c-.19-.08-.36-.19-.49-.32-.14-.14-.24-.3-.31-.5-.07-.19-.11-.4-.11-.62v-2.26h.7v2.25c0,.14,.02,.27,.06,.39,.04,.12,.09,.22,.17,.3,.07,.08,.16,.15,.27,.19,.11,.05,.23,.07,.36,.07Z"
                                                  style="fill: #a0cf67"
                                                  />
                                                  <path d="M28.11,24.55v.58h-1.13v3.19h-.7v-3.19h-1.14v-.58h2.97Z" style="fill: #a0cf67" />
                                                  <path d="M29.24,28.32h-.7v-3.77h.7v3.77Z" style="fill: #a0cf67" />
                                                  <path
                                                    d="M33.6,26.43c0,.28-.05,.53-.14,.77-.09,.24-.22,.44-.39,.61-.17,.17-.37,.3-.6,.4-.23,.1-.5,.15-.78,.15s-.54-.05-.78-.15c-.24-.1-.44-.23-.6-.4-.17-.17-.3-.38-.39-.61-.09-.23-.14-.49-.14-.77s.04-.53,.14-.77c.09-.24,.22-.44,.39-.61,.17-.17,.37-.31,.6-.4,.24-.1,.5-.15,.78-.15s.55,.05,.78,.15c.24,.1,.44,.23,.6,.4,.17,.17,.3,.37,.39,.61,.09,.23,.14,.49,.14,.77Zm-.72,0c0-.21-.03-.39-.08-.56-.06-.16-.13-.3-.23-.42-.1-.12-.23-.21-.38-.27-.15-.06-.31-.09-.5-.09s-.35,.03-.5,.09c-.15,.06-.27,.15-.38,.27-.1,.11-.18,.25-.24,.42-.06,.16-.08,.35-.08,.56s.03,.39,.08,.56c.05,.16,.13,.3,.24,.42,.1,.11,.23,.2,.38,.26,.15,.06,.31,.09,.5,.09s.35-.03,.5-.09c.15-.06,.27-.15,.38-.26,.1-.11,.18-.26,.23-.42,.06-.16,.08-.35,.08-.56Z"
                                                    style="fill: #a0cf67"
                                                    />
                                                    <path
                                                      d="M34.49,24.55s.04,0,.05,.02c.02,0,.03,.02,.05,.03,.02,.01,.03,.03,.05,.06l1.98,2.52c0-.06-.01-.12-.01-.18,0-.06,0-.12,0-.16v-2.29h.62v3.77h-.36c-.05,0-.1,0-.14-.03-.04-.02-.07-.05-.11-.09l-1.98-2.51c0,.06,0,.11,.01,.16,0,.06,0,.11,0,.15v2.31h-.61v-3.77h.37s.06,0,.08,0Z"
                                                      style="fill: #a0cf67"
                                                      />
                                                      <path
                                                        d="M40.01,25.23s-.04,.07-.07,.08c-.03,.02-.06,.02-.09,.02s-.07-.01-.12-.04c-.04-.03-.09-.06-.15-.09-.06-.03-.13-.06-.2-.09-.08-.03-.17-.04-.28-.04-.1,0-.18,0-.25,.03-.07,.03-.13,.06-.18,.1-.05,.04-.08,.09-.11,.15-.02,.06-.04,.12-.04,.19,0,.09,.02,.16,.07,.22,.05,.06,.11,.11,.2,.15,.08,.04,.17,.08,.28,.11,.1,.03,.21,.07,.32,.11,.11,.04,.22,.08,.32,.13,.11,.05,.2,.11,.28,.19,.08,.07,.15,.17,.2,.28,.05,.11,.07,.24,.07,.4,0,.17-.03,.33-.09,.48-.06,.15-.14,.28-.26,.39-.11,.11-.25,.2-.41,.26-.16,.06-.35,.1-.56,.1-.12,0-.24-.01-.35-.03-.12-.02-.23-.06-.33-.1-.11-.04-.21-.1-.3-.16-.09-.06-.18-.13-.25-.2l.2-.34s.04-.05,.07-.06c.03-.02,.06-.02,.09-.02,.04,0,.09,.02,.14,.05,.05,.04,.11,.08,.18,.12,.07,.04,.15,.08,.24,.12,.09,.04,.2,.05,.33,.05,.2,0,.36-.05,.47-.14,.11-.09,.16-.23,.16-.41,0-.1-.03-.18-.07-.24-.05-.06-.12-.11-.2-.16-.08-.04-.18-.08-.28-.11-.1-.03-.21-.06-.32-.1-.11-.03-.21-.08-.32-.12-.1-.05-.2-.11-.28-.19-.08-.08-.15-.17-.2-.29-.05-.12-.08-.26-.08-.43,0-.14,.03-.27,.08-.4,.05-.13,.14-.25,.24-.35,.1-.1,.23-.18,.39-.24,.15-.06,.33-.09,.52-.09,.22,0,.43,.03,.62,.11,.19,.07,.35,.17,.48,.29l-.17,.33Z"
                                                        style="fill: #a0cf67"
                                                        />
                                                      </g>
                                                    </g>
                                                  </g>
                                                </g>
                                              </svg>
                                            </div>
                                          }
                                          <div class="flex-container system-account-container">
                                            <ng-container>
                                              @if (currentUser.isSystemUser && !isOnSystemPage) {
                                                <h1 class="page-type"
                                                  >{{ selectedAccountName }}
                                                  @if (currentUser.isSystemUser && !isOnSystemPage) {
                                                    <a
                                                      color="primary"
                                                      class="switch-account-button"
                                                      mat-button
                                                      [routerLink]="accountsRoute"
                                                      [href]="accountsRoute"
                                                      >Change Account</a
                                                      >
                                                    }
                                                  </h1>
                                                }
                                                <ng-template #systemHeader><h1 class="page-type">System</h1></ng-template>
                                              </ng-container>
                                            </div>
                                            @if (mobileView && privileges) {
                                              <div class="mobile-menu">
                                                <div class="mobile-logo">
                                                  <svg class="ndt-logo" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                      d="M11.27,4.13c-3,0-6.48,2.57-6.48,7.44s3.43,7.49,6.48,7.49,6.44-2.18,6.44-7.49S14.44,4.13,11.27,4.13Z"
                                                      style="fill: none"
                                                      />
                                                      <path
                                                        d="M17.49.26V3.18C16.49,1.65,14.31,0,10.66,0,5.87,0,0,3.83,0,11.57S5.87,23.19,10.66,23.19c3.65,0,6.66-2.13,6.83-4V32h4.79V.26Zm-6.22,18.8c-3,0-6.48-2.57-6.48-7.49s3.43-7.44,6.48-7.44,6.44,2.09,6.44,7.44S14.44,19.06,11.27,19.06Z"
                                                        style="fill: #00a7e1"
                                                        />
                                                      </svg>
                                                    </div>
                                                    <button mat-icon-button [matMenuTriggerFor]="mobileMenu">
                                                      <mat-icon class="mobile-menu-icon">menu</mat-icon>
                                                    </button>
                                                    <mat-menu #nestedMenu>
                                                      <ng-template matMenuContent let-items>
                                                        @for (item of items; track item) {
                                                          <a
                                                            mat-menu-item
                                                            [routerLink]="item.routerLink"
                                                            [queryParamsHandling]="item.queryParamsHandling"
                                                            >
                                                            @if (item.icon) {
                                                              <mat-icon>{{ item.icon }}</mat-icon>
                                                            }
                                                            <span>{{ item.name }}</span>
                                                          </a>
                                                        }
                                                      </ng-template>
                                                    </mat-menu>
                                                    <mat-menu #mobileMenu>
                                                      @for (item of menuItems; track item) {
                                                        @if (item.children && item.children.length > 0 && !item.isSpacer) {
                                                          <button
                                                            type="button"
                                                            mat-menu-item
                                                            [matMenuTriggerFor]="nestedMenu"
                                                            [matMenuTriggerData]="{ $implicit: item.children }"
                                                            >
                                                            {{ item.name }}
                                                          </button>
                                                        } @else {
                                                          @if (!item.isSpacer) {
                                                            <a
                                                              mat-menu-item
                                                              [routerLink]="item.routerLink"
                                                              [queryParamsHandling]="item.queryParamsHandling"
                                                              >
                                                              {{ item.name }}
                                                            </a>
                                                          }
                                                          @if (privileges.reports[reports.UserActivitySummary]) {
                                                            <a
                                                              mat-menu-item
                                                              [routerLink]="['/reports/user-activity-summary']"
                                                              routerLinkActive="active-page"
                                                              class="nav-item"
                                                              >
                                                              <div class="nav-item-text">'User' Activity Summary Report</div>
                                                            </a>
                                                          }
                                                          @if (privileges.reports[reports.UserActivityDetail]) {
                                                            <a
                                                              mat-menu-item
                                                              [routerLink]="['/reports/user-activity-detail']"
                                                              routerLinkActive="active-page"
                                                              class="nav-item"
                                                              >
                                                              <div class="nav-item-text">User Activity Detail Report</div>
                                                            </a>
                                                          }
                                                        }
                                                      }
                                                      @if (privileges.reports[reports.UserActivitySummary]) {
                                                        <a
                                                          mat-menu-item
                                                          [routerLink]="['/reports/user-activity-summary']"
                                                          routerLinkActive="active-page"
                                                          class="nav-item"
                                                          >
                                                          <div class="nav-item-text">User Activity Summary Report</div>
                                                        </a>
                                                      }
                                                      @if (privileges.reports[reports.UserActivityDetail]) {
                                                        <a
                                                          mat-menu-item
                                                          [routerLink]="['/reports/user-activity-detail']"
                                                          routerLinkActive="active-page"
                                                          class="nav-item"
                                                          >
                                                          <div class="nav-item-text">User Activity Detail Report</div>
                                                        </a>
                                                      }
                                                      @if (privileges.reports[reports.UserEfficiency]) {
                                                        <a
                                                          mat-menu-item
                                                          [routerLink]="['/reports/user-efficiency']"
                                                          routerLinkActive="active-page"
                                                          class="nav-item"
                                                          >
                                                          <div class="nav-item-text">User Efficiency Report</div>
                                                        </a>
                                                      }
                                                    </mat-menu>
                                                  </div>
                                                }
                                                <div class="global-search-container" #searchContainer>
                                                  <form [formGroup]="form" class="global-search" (ngSubmit)="onSubmit()">
                                                    <input
                                                      cdkOverlayOrigin
                                                      #searchInput
                                                      #overlayOrigin="cdkOverlayOrigin"
                                                      autocomplete="off"
                                                      id="global-search-input"
                                                      type="text"
                                                      placeholder="Search"
                                                      aria-label="Search"
                                                      formControlName="searchText"
                                                      />
                                                      <button mat-button type="submit" matTooltip="Search">
                                                        <mat-icon class="global-search-icon" #searchButton>search</mat-icon>
                                                      </button>
                                                      <ng-template
                                                        cdkConnectedOverlay
                                                        [cdkConnectedOverlayOrigin]="overlayOrigin"
                                                        [cdkConnectedOverlayOpen]="showDropdown"
                                                        class="results-container"
                                                        >
                                                        <ndt-global-search
                                                          (itemSelectedCompleted)="handleItemSelectCompleted()"
                                                          (clickedInside)="handleClickInside($event, true)"
                                                        ></ndt-global-search>
                                                      </ng-template>
                                                      @if (searchTextFormControl.hasError('minlength')) {
                                                        <span class="global-search-validation-errors">
                                                          Searching requires at least three characters
                                                        </span>
                                                      }
                                                    </form>
                                                  </div>
                                                  <button
                                                    id="178bab99-3132-497c-a6d3-11f8507f4b51"
                                                    type="button"
                                                    attr.aria-label="User Account Menu"
                                                    [matMenuTriggerFor]="accountMenu"
                                                    class="user-account-name"
                                                    matTooltip="Account Settings"
                                                    >
                                                    <ndt-avatar [name]="currentUser?.name" [fileToken]="$any(currentUser)?.profileImage"></ndt-avatar>
                                                  </button>
                                                </div>
                                              }
                                              <router-outlet></router-outlet>
                                            </div>

                                            <mat-menu #accountMenu="matMenu" class="current-user-menu-panel">
                                              <a
                                                disabled
                                                routerLink="./"
                                                queryParamsHandling="merge"
                                                mat-menu-item
                                                attr.aria-label="User Profile"
                                                class="current-user-profile-menu-item"
                                                >
                                                <div class="current-user-profile">
                                                  <div class="current-user-info">
                                                    <div class="current-user-name" id="current-user-full-name">{{ currentUser?.name }}</div>
                                                    <div class="current-user-email">{{ currentUser?.emailAddress }}</div>
                                                  </div>
                                                </div>
                                              </a>
                                              @if (adminToken) {
                                                <mat-slide-toggle
                                                  class="preference-toggles"
                                                  color="primary"
                                                  labelPosition="before"
                                                  (change)="onCustomerViewClick($event)"
                                                  (click)="$event.stopPropagation()"
                                                  >Customer View</mat-slide-toggle
                                                  >
                                              }
                                              <!-- slider to disable the tooltips entirely
                                              <mat-slide-toggle
                                                class="preference-toggles"
                                                [ngModel]="showExtensionRegisterPopup"
                                                (ngModelChange)="onToggleShowExtensionRegisterPopup($event)"
                                                (click)="$event.stopPropagation()"
                                                labelPosition="before"
                                                >Show Popups</mat-slide-toggle
                                                >-->
                                                <button type="button" mat-menu-item (click)="onUserPreferencesClick()"> User Preferences </button>

                                                <!--TODO implement changing password - NDT-8873-->
                                                <!-- <button *ngIf="isLocalUser" type="button" mat-menu-item (click)="onChangePasswordClick()"> Change Password </button> -->

                                                @if (mobileView) {
                                                  <button type="button" mat-menu-item> Notifications </button>
                                                  <button type="button" mat-menu-item> Help </button>
                                                }

                                                <button
                                                  id="28e36e03-c41c-4bb8-a175-d89269ad6860"
                                                  type="button"
                                                  mat-menu-item
                                                  (click)="onSignOutClick()"
                                                  class="sign-out"
                                                  >
                                                  <mat-icon>exit_to_app</mat-icon>
                                                  <span>Sign Out</span>
                                                </button>
                                              </mat-menu>
